import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { HighlightPipe } from 'ish-core/pipes/highlight.pipe';
import { CategoryRoutePipe } from 'ish-core/routing/category/category-route.pipe';
import { CategoryImageComponent } from 'ish-shared/components/category/category-image/category-image.component';

@Component({
  selector: 'ish-suggest-categories-tile',
  imports: [CommonModule, HighlightPipe, CategoryRoutePipe, RouterModule, CategoryImageComponent],
  templateUrl: './suggest-categories-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestCategoriesTileComponent implements OnInit {
  private shoppingFacade = inject(ShoppingFacade);

  readonly categoryUniqueId = input.required<string>();
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly routeChange = output<void>();

  category$: Observable<CategoryView>;

  ngOnInit() {
    this.category$ = this.shoppingFacade.category$(this.categoryUniqueId());
  }

  handleInputFocus(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.routeChange.emit();
  }
}
